export const articles = [
  {
    id: 1,
    title: 'SSIS-001 全面解析：番号查询与作品详情',
    slug: 'ssis-001-full-review',
    excerpt: '本文为您详细解析 SSIS-001 的完整信息，包括作品背景、出演阵容、剧情概览以及番号分类归属，帮助您全面了解这部作品的各项细节。',
    content: `SSIS-001 是近年来备受关注的一部作品。本文将从多个维度对该番号进行深入分析。

## 作品背景

SSIS 系列作为业内知名厂牌的重要产品线，一直以来都以高制作水准和精良的内容著称。SSIS-001 作为该系列的开篇之作，承载了厂牌的战略定位与品质承诺。

## 出演阵容

本作品汇集了业界顶尖的演出阵容，每位出演者都以其专业的表演功底为作品增色不少。导演在选角方面下足了功夫，确保了作品的观感体验与艺术水准。

## 剧情概览

故事围绕都市生活中的情感纠葛展开，叙事节奏紧凑且富有张力。编剧通过细腻的情节推进和人物刻画，为观众呈现了一部既有深度又具观赏性的作品。

## 技术参数

- 番号编号：SSIS-001
- 发行日期：2023年
- 片长：约120分钟
- 画质：高清
- 分类：单片推荐 / 热门番号

## 综合评价

综合来看，SSIS-001 在制作水准、演出表现和剧情设计方面都达到了较高水平，是一部值得收藏和反复观看的优质番号作品。`,
    category: 'danpian',
    categoryName: '单片推荐',
    date: '2026-08-05',
    readTime: '8分钟',
    views: 12580,
    tags: ['SSIS', '单片推荐', '高清', '热门'],
    imageSeq: 'article-ssis-001',
  },
  {
    id: 2,
    title: 'MIDV-001 番号查询指南：从入门到精通',
    slug: 'midv-001-query-guide',
    excerpt: 'MIDV-001 作为 MIDV 系列的标杆之作，本文带您深入了解该番号的方方面面，包括如何高效查询、分类归属以及相关推荐番号。',
    content: `MIDV-001 是 MIDV 系列的重要作品，本文为您提供全面的番号查询与解读。

## 系列介绍

MIDV 系列以其独特的风格定位在番号市场中占据了一席之地。MIDV-001 作为系列首部作品，奠定了整个系列的基调与品质标准。

## 查询方法

查询 MIDV-001 番号可以通过以下几种方式：

1. 直接在番号本搜索框输入 "MIDV-001"
2. 通过分类浏览进入"单片推荐"栏目
3. 使用标签筛选功能查找 MIDV 系列

## 作品特色

本作品在视觉呈现和叙事手法上都有独到之处，制作团队在场景设计和灯光运用上花费了大量心思，为观众带来沉浸式的观看体验。

## 详细信息

- 番号编号：MIDV-001
- 发行日期：2023年
- 片长：约150分钟
- 画质：超高清
- 分类：单片推荐 / 高清资源

## 相关推荐

如果您喜欢 MIDV-001，以下番号也值得关注：MIDV-002、MIDV-005、MIDV-010。`,
    category: 'danpian',
    categoryName: '单片推荐',
    date: '2026-08-04',
    readTime: '6分钟',
    views: 9842,
    tags: ['MIDV', '单片推荐', '超高清', '查询指南'],
    imageSeq: 'article-midv-001',
  },
  {
    id: 3,
    title: '2026年8月热门番号排行榜 TOP 20',
    slug: '2026-august-top-20',
    excerpt: '每月更新的热门番号排行榜来了！本文整理了2026年8月最受关注的前20部番号，包含详细的排名变化分析和作品亮点解读。',
    content: `每月番号排行榜是番号本最受欢迎的栏目之一。以下是2026年8月的热门番号 TOP 20。

## 排名变化分析

本月榜单相比上月有较大变动，多个新番号进入前20名。全新番号的涌入为榜单注入了新鲜血液，同时部分经典番号依然稳居前列。

## TOP 20 榜单

1. SSIS-010 - 上升3位，热度持续攀升
2. MIDV-005 - 新上榜，表现亮眼
3. IPX-001 - 保持稳定
4. ABW-001 - 略有下滑
5. STARS-001 - 大幅上升

（完整榜单请查看原文）

## 趋势解读

本月榜单呈现出几个明显趋势：新番号占比提升、高清资源更受欢迎、系列作品抱团上榜现象明显。

## 月度总结

2026年8月的番号市场呈现出蓬勃发展的态势，各类优秀作品层出不穷。番号本将持续为您追踪最新动态。`,
    category: 'remen',
    categoryName: '热门番号',
    date: '2026-08-03',
    readTime: '10分钟',
    views: 23567,
    tags: ['排行榜', '热门', '2026', '月度', 'TOP20'],
    imageSeq: 'article-top20',
  },
  {
    id: 4,
    title: '经典番号系列回顾：那些年我们追过的 IPX 系列',
    slug: 'ipx-series-retrospective',
    excerpt: 'IPX 系列自诞生以来就备受关注，本文带您回顾 IPX 系列的经典之作，从 IPX-001 到最新作品，一次看个够。',
    content: `IPX 系列是番号界的传奇品牌之一，本文将带您回顾这个经典系列的发展历程。

## 系列起源

IPX 系列诞生于行业发展的高峰期，以其创新的制作理念和精良的内容品质迅速赢得了大量粉丝的青睐。

## 里程碑作品

- IPX-001：系列开篇之作，奠定了品质基调
- IPX-050：里程碑式的第50部作品
- IPX-100：百部纪念作品，制作规格全面升级

## 系列特色

IPX 系列的核心特色在于其对作品品质的一贯坚持。无论是画面质感、剧情编排还是表演呈现，始终保持行业领先水准。

## 影响力评估

经过多年的发展，IPX 系列已经成为番号领域最具影响力的品牌之一，其作品被广泛收藏和讨论。

## 未来展望

随着系列的持续发展，IPX 将继续推出更多优质番号作品，番号本也将持续关注并为您带来第一手资讯。`,
    category: 'jingdian',
    categoryName: '经典番号',
    date: '2026-08-02',
    readTime: '12分钟',
    views: 7891,
    tags: ['IPX', '经典', '系列回顾', '合集'],
    imageSeq: 'article-ipx',
  },
  {
    id: 5,
    title: '番号搜索技巧大全：如何精准找到你想要的番号',
    slug: 'search-tips-guide',
    excerpt: '还在为找不到想要的番号而烦恼吗？本文整理了最全面的番号搜索技巧，从基础到进阶，让您成为番号搜索达人。',
    content: `在庞大的番号数据库中精准找到目标番号，需要掌握一些搜索技巧。本文将为您全面解析。

## 基础搜索技巧

1. 精确番号搜索：直接输入完整番号编号
2. 系列搜索：输入系列前缀如 "SSIS"、"IPX"
3. 关键词搜索：使用作品相关的关键词

## 进阶搜索方法

1. 组合搜索：番号前缀 + 分类标签
2. 时间范围筛选：限定发行时间区间
3. 多条件过滤：同时使用多个筛选条件

## 分类浏览技巧

番号本提供了完善的分类体系，您可以通过以下分类快速定位目标番号：

- 按年份浏览
- 按系列浏览
- 按类型浏览
- 按热度排序

## 常见问题解答

Q: 搜索不到番号怎么办？
A: 尝试使用番号的部分编号进行模糊搜索，或通过分类浏览查找。

Q: 如何搜索最新的番号？
A: 进入"全新番号"分类，按发布时间倒序排列即可。

## 总结

掌握这些搜索技巧后，您就能在番号本的海量数据库中快速准确地找到目标番号了。`,
    category: 'zhuanji',
    categoryName: '专题策划',
    date: '2026-08-01',
    readTime: '7分钟',
    views: 15623,
    tags: ['搜索技巧', '教程', '指南', '专题'],
    imageSeq: 'article-search-tips',
  },
  {
    id: 6,
    title: '新人番号速递：2026年夏季新番号作品一览',
    slug: '2026-summer-new-releases',
    excerpt: '2026年夏季新番号作品全面盘点！本文整理了本季最值得关注的新番号，涵盖多个系列和类型，让您不错过任何精彩。',
    content: `2026年夏季，番号市场迎来了新一轮的作品发布高峰。本文将为您盘点本季最值得关注的新番号。

## 本季亮点

今年夏季的番号作品呈现出多元化的发展趋势，制作水准整体提升，多个系列推出了令人耳目一新的作品。

## 重点新番推荐

1. SSIS-020：年度重磅作品
2. MIDV-015：系列最新力作
3. IPX-120：经典系列新篇章
4. STARS-030：黑马之姿
5. ABW-050：品质保证

## 新人作品推荐

本季也涌现了一批优秀的新人番号作品：

- FSDSS-001：新人出道作品，表现惊艳
- JUL-001：实力派新人，值得关注

## 夏季趋势

1. 高清制作成为标配
2. 系列化运营更加成熟
3. 题材多元化趋势明显

番号本将持续关注新番号动态，为您带来最及时的更新信息。`,
    category: 'quanxin',
    categoryName: '全新番号',
    date: '2026-07-30',
    readTime: '9分钟',
    views: 18765,
    tags: ['新人', '2026', '夏季', '新番号', '速递'],
    imageSeq: 'article-summer-new',
  },
  {
    id: 7,
    title: '高清番号资源指南：4K画质番号作品推荐',
    slug: '4k-high-quality-guide',
    excerpt: '追求极致画质体验？本文为您精选了多部4K高清番号作品，从画面质量到内容品质进行全面评测和推荐。',
    content: `随着技术发展，4K高清番号作品越来越受到观众的青睐。本文为您推荐多部画质出众的番号作品。

## 4K番号的优势

1. 画质细腻度大幅提升
2. 色彩还原更加真实
3. 细节表现力显著增强
4. 沉浸式观看体验

## 推荐作品

1. IPX-100：4K画质标杆之作
2. SSIS-015：画面质感一流
3. MIDV-020：视觉效果出众
4. STARS-025：色彩表现极佳

## 观看建议

- 推荐使用4K显示器或电视观看
- 确保网络带宽充足
- 搭配高品质音响设备效果更佳

## 技术参数解读

了解番号的画质参数有助于您做出更好的选择。常见的画质标识包括：
- FHD：全高清（1080P）
- 4K：超高清（2160P）
- HDR：高动态范围

番号本的高清资源分类将持续更新，为您提供最优质的番号画质体验。`,
    category: 'gaoqing',
    categoryName: '高清资源',
    date: '2026-07-28',
    readTime: '8分钟',
    views: 11234,
    tags: ['4K', '高清', '画质', '推荐', '指南'],
    imageSeq: 'article-4k',
  },
  {
    id: 8,
    title: '番号收藏管理指南：如何高效整理你的番号库',
    slug: 'collection-management-guide',
    excerpt: '番号收藏数量日益增长，如何高效管理成了难题。本文分享实用的番号收藏管理方法，帮助您打造专属的番号数据库。',
    content: `随着番号收藏数量的增长，高效的管理方法变得至关重要。本文为您提供实用的番号收藏管理指南。

## 管理原则

1. 分类清晰：按系列、类型、年份等维度分类
2. 标签系统：建立个性化的标签体系
3. 定期整理：保持收藏库的整洁有序

## 分类方法

### 按系列分类
- SSIS 系列
- IPX 系列
- MIDV 系列
- STARS 系列

### 按类型分类
- 单片推荐
- 合集系列
- 经典番号
- 新人作品

### 按年份分类
- 2026年
- 2025年
- 2024年及更早

## 番号本收藏功能

番号本即将推出个人收藏功能，届时您可以：

1. 一键收藏番号
2. 创建自定义分类
3. 添加个人备注
4. 导出收藏列表

## 最佳实践

1. 收藏时及时添加标签
2. 定期回顾和整理
3. 善用搜索和筛选功能
4. 保持分类体系的一致性

高效的番号管理让您的收藏更有价值。`,
    category: 'zhuanji',
    categoryName: '专题策划',
    date: '2026-07-25',
    readTime: '6分钟',
    views: 8934,
    tags: ['收藏', '管理', '指南', '整理', '专题'],
    imageSeq: 'article-collection',
  },
  {
    id: 9,
    title: 'ABW 系列全解析：从 ABW-001 到最新作品',
    slug: 'abw-series-full-analysis',
    excerpt: 'ABW 系列是番号领域不可忽视的重要力量。本文全面解析 ABW 系列的发展历程、代表作品和未来趋势。',
    content: `ABW 系列在番号领域有着举足轻重的地位，本文将对该系列进行全面解析。

## 系列概况

ABW 系列以其独特的创作理念和稳定的品质输出，在番号爱好者中积累了良好口碑。

## 代表作品回顾

- ABW-001：系列开篇，一鸣惊人
- ABW-050：中期代表作
- ABW-100：百部纪念作品

## 系列特色分析

ABW 系列的核心竞争力在于：
1. 稳定的作品质量
2. 多样化的题材选择
3. 优秀的出演阵容
4. 精良的制作水准

## 市场表现

ABW 系列在各项数据指标上都表现出色：
- 搜索量：名列前茅
- 收藏量：持续增长
- 好评率：稳定在高位

## 最新动态

ABW 系列近期发布的几部新作品都获得了不错的反响，系列发展势头良好。番号本将持续跟踪报道。`,
    category: 'jingdian',
    categoryName: '经典番号',
    date: '2026-07-22',
    readTime: '11分钟',
    views: 10234,
    tags: ['ABW', '系列', '经典', '全解析'],
    imageSeq: 'article-abw',
  },
  {
    id: 10,
    title: 'STARS 系列新品速递：最新番号作品抢先看',
    slug: 'stars-series-new-releases',
    excerpt: 'STARS 系列近期一口气发布了多部新番号作品！本文为您带来 STARS 系列最新番号的详细信息和第一手评测。',
    content: `STARS 系列近期发布了多部备受期待的新番号作品，本文将为您带来最新速递。

## 新作品列表

1. STARS-030：系列新高度
2. STARS-031：延续高品质
3. STARS-032：创新题材尝试

## 作品评测

每部新作品都经过了专业评测团队的详细评测，从画质、剧情、表演等多个维度进行了全面打分。

## 与往期作品对比

相比往期作品，新番号在以下方面有了明显提升：
1. 画质全面升级
2. 剧情更加丰富
3. 制作更加精细

## 用户反馈

新作品发布后收到了用户的积极反馈：
- 好评率：92%
- 收藏率：同比增长30%
- 推荐指数：4.8/5

## 购买指南

如果您对 STARS 系列新作品感兴趣，可以通过番号本搜索完整番号编号获取详细信息。`,
    category: 'quanxin',
    categoryName: '全新番号',
    date: '2026-07-20',
    readTime: '7分钟',
    views: 14567,
    tags: ['STARS', '新品', '评测', '速递'],
    imageSeq: 'article-stars',
  },
];

export const articlesByCategory: Record<string, number[]> = {
  quanxin: [6, 10],
  remen: [3],
  jingdian: [4, 9],
  heji: [],
  danpian: [1, 2],
  gaoqing: [7],
  xinren: [],
  zhuanji: [5, 8],
};